import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, MapPin, Clock, Instagram } from 'lucide-react';
export function Contact() {
  return <section id="contacto" className="py-32 bg-brand-black relative" data-id="element-171">
      <div className="max-w-7xl mx-auto px-6" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-173">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white" data-id="element-174">
            <span className="text-brand-gold" data-id="element-175">Encontranos</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-176">
          {/* Left - Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-177">
            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-178">
              <MessageCircle className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-179" />
              <div data-id="element-180">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-181">
                  WhatsApp
                </h3>
                <p className="text-brand-white/70 mb-4" data-id="element-182">+54 9 11 6889-8054</p>
                <a href="https://wa.me/5491168898054" target="_blank" rel="noopener noreferrer" className="inline-flex px-6 py-2 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors text-sm" data-id="element-183">
                  Escribinos
                </a>
              </div>
            </div>

            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-184">
              <MapPin className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-185" />
              <div data-id="element-186">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-187">
                  Dirección
                </h3>
                <p className="text-brand-white/70" data-id="element-188">
                  Los Patos 2927, Parque Patricios, CABA
                </p>
              </div>
            </div>

            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-189">
              <Clock className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-190" />
              <div data-id="element-191">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-192">
                  Horario
                </h3>
                <p className="text-brand-white/70" data-id="element-193">
                  Lunes a sábados de 9 a 19hs
                </p>
              </div>
            </div>

            <div className="bg-[#111] border border-brand-gold/30 p-6 rounded-xl flex items-start gap-4" data-id="element-194">
              <Instagram className="w-8 h-8 text-brand-gold shrink-0 mt-1" data-id="element-195" />
              <div data-id="element-196">
                <h3 className="text-brand-white font-bold text-lg mb-1" data-id="element-197">
                  Redes Sociales
                </h3>
                <div className="flex gap-4 mt-2" data-id="element-198">
                  <a href="https://instagram.com/flash.go.arg" target="_blank" rel="noopener noreferrer" className="text-brand-white/70 hover:text-brand-gold transition-colors" data-id="element-199">
                    @flash.go.arg
                  </a>
                  <span className="text-brand-white/30" data-id="element-200">|</span>
                  <a href="https://tiktok.com/@flashgo.arg" target="_blank" rel="noopener noreferrer" className="text-brand-white/70 hover:text-brand-gold transition-colors" data-id="element-201">
                    TikTok: @flashgo.arg
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right - Map */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="h-[500px] rounded-xl overflow-hidden border border-brand-gold/30" data-id="element-202">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.805820461877!2d-58.40388102340813!3d-34.63433606044738!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccb17130f1465%3A0x6395b281b3726c04!2sLos%20Patos%202927%2C%20C1437%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires!5e0!3m2!1sen!2sar!4v1717684000000!5m2!1sen!2sar" width="100%" height="100%" style={{
            border: 0,
            filter: 'invert(90%) hue-rotate(180deg) contrast(100%)'
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-203"></iframe>
          </motion.div>
        </div>
      </div>
    </section>;
}